import React, { useState, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Box,
  Flex,
  Input,
  Select,
  Button,
  Heading,
  SimpleGrid,
  Text,
  Stack,
  Divider,
  Image,
  Badge,
  ChakraProvider,
  Container,
  Checkbox,
  CheckboxGroup,
} from "@chakra-ui/react";
import eng from "assets/img/5.png";
import math from "assets/img/math.jpg";
import mathPost from "assets/img/1.png";
import mathPre from "assets/img/2.png";
import sciPost from "assets/img/3.png";
import sciPre from "assets/img/4.png";
import sci from "assets/img/sci.jpg";
import social from "assets/img/6.png";
import thai from "assets/img/7.png";
import PanelContainer from "components/Layout/PanelContainer";
import { Link } from "react-router-dom";
import { GET_COURSES_BY_GUEST } from 'store/guests'


const SearchBar = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <Box mb={6}>
      <Input
        placeholder="ค้นหา"
        size="lg"
        borderRadius="full"
        value={searchTerm}
        onChange={(e) => {
          setSearchTerm(e.target.value);
          onSearch(e.target.value);
        }}
      />
    </Box>
  );
};

const FilterBar = ({ onFilter }) => {
  const [coursetype, setCoursetype] = useState("all");
  const [classroom, setClassroom] = useState([]);
  const [subject, setSubject] = useState([]);

  const updateFilters = (newFilters) => {
    onFilter(newFilters);
  };

  const handleCoursetypeChange = (values) => {
    setCoursetype(values);
    updateFilters({ coursetype: values, classroom, subject });
  };

  const handleClassroomChange = (values) => {
    setClassroom(values);
    updateFilters({ coursetype, classroom: values, subject });
  };

  const handleSubjectChange = (values) => {
    setSubject(values);
    updateFilters({ coursetype, classroom, subject: values });
  };

  return (
    <Stack spacing={4} p={4} borderWidth="1px" borderRadius="lg" shadow="sm" bg="white">
      <Heading size="md" mb={2}>
        ตัวกรองชุดข้อสอบ
      </Heading>

      <Box>
        <Flex gap={2}>
          {/* Button for showing all courses */}
          <Button
            colorScheme={coursetype === "all" ? "teal" : "gray"}
            onClick={() => handleCoursetypeChange("all")}
          >
            ชุดข้อสอบทั้งหมด
          </Button>

          {/* Button for showing free courses */}
          <Button
            colorScheme={coursetype === "free" ? "teal" : "gray"}
            onClick={() => handleCoursetypeChange("free")}
          >
            ชุดข้อสอบฟรี
          </Button>
        </Flex>
      </Box>
      <Flex direction={{ base: "column", md: "row", lg: "column" }} p={1} gap={6}>
        <Box flex="1">
          <Heading size="sm" mb={2}>
            เลือกชั้นเรียน
          </Heading>
          <CheckboxGroup value={classroom} onChange={handleClassroomChange}>
            <Stack direction="column" spacing={2}>
              <Checkbox value="ประถมศึกษาปีที่ 1">ประถมศึกษาปีที่ 1</Checkbox>
              <Checkbox value="ประถมศึกษาปีที่ 2">ประถมศึกษาปีที่ 2</Checkbox>
              <Checkbox value="ประถมศึกษาปีที่ 3">ประถมศึกษาปีที่ 3</Checkbox>
              <Checkbox value="ประถมศึกษาปีที่ 4">ประถมศึกษาปีที่ 4</Checkbox>
              <Checkbox value="ประถมศึกษาปีที่ 5">ประถมศึกษาปีที่ 5</Checkbox>
              <Checkbox value="ประถมศึกษาปีที่ 6">ประถมศึกษาปีที่ 6</Checkbox>
              <Checkbox value="มัธยมศึกษาปีที่ 1">มัธยมศึกษาปีที่ 1</Checkbox>
              <Checkbox value="มัธยมศึกษาปีที่ 2">มัธยมศึกษาปีที่ 2</Checkbox>
              <Checkbox value="มัธยมศึกษาปีที่ 3">มัธยมศึกษาปีที่ 3</Checkbox>
            </Stack>
          </CheckboxGroup>
        </Box>

        <Box flex="1">
          <Heading size="sm" mb={2}>
            เลือกวิชา
          </Heading>
          <CheckboxGroup value={subject} onChange={handleSubjectChange}>
            <Stack direction="column" spacing={2}>
              <Checkbox variant='outline' value='ภาษาไทย'>ภาษาไทย</Checkbox>
              <Checkbox variant='outline' value='คณิตศาสตร์'>คณิตศาสตร์</Checkbox>
              <Checkbox variant='outline' value='วิทยาศาสตร์'>วิทยาศาสตร์</Checkbox>
              <Checkbox variant='outline' value='สังคมศึกษา'>สังคมศึกษา</Checkbox>
              <Checkbox variant='outline' value='ภาษาอังกฤษ'>ภาษาอังกฤษ</Checkbox>
            </Stack>
          </CheckboxGroup>
        </Box>
      </Flex>
    </Stack>
  );
};

const CourseCard = ({ course }) => {
  const discountedPrice = course.sale_price
    ? (parseFloat(course.original_price) - parseFloat(course.sale_price)).toFixed(2)
    : null;

  const imageSubject = (subject, classNum) => {
    let num = classNum && classNum.split(' ')[1]
    if (subject == 'คณิตศาสตร์' && num < 4) {
      return mathPre
    } else if (subject == 'คณิตศาสตร์' && num >= 4) {
      return mathPost
    }  else if (subject == 'วิทยาศาสตร์' && num < 4) {
      return sciPre
    } else if (subject == 'วิทยาศาสตร์' && num >= 4) {
      return sciPost
    } else if (subject == 'สังคมศึกษา') {
      return social
    } else if (subject == 'ภาษาอังกฤษ') {
      return eng
    } else if (subject == 'ภาษาไทย') {
      return thai
    }
  }

  return (
    <Box
      bg="white"
      boxShadow="md"
      borderRadius="md"
      overflow="hidden"
    >
      <Image
        src={course.url_image || imageSubject(course.subject, course.class)}
        alt={`Course ${course.id}`}
        w="full"
        objectFit="cover"
      />
      <Stack spacing={2} padding={4}>
        <Text fontWeight="bold" fontSize="lg" noOfLines={2}>
          {course.name}
        </Text>
        <Text fontSize="sm" color="gray.600">
          <Badge mr={2}>{course.class}</Badge>
          <Badge>{course.subject}</Badge>
        </Text>
        <Flex alignItems="center" gap={2}>
          {course.sale_price ? (
            <>
              <Text fontWeight="bold" fontSize="xl" color="teal.600">
                ฿{course.sale_price}
              </Text>
              <Text
                as="s"
                color="gray.500"
                fontSize="sm"
              >
                ฿{course.original_price}
              </Text>
            </>
          ) : (
            <Text fontWeight="bold" fontSize="xl" color="teal.600">
              ฿{course.original_price}
            </Text>
          )}
        </Flex>
        {discountedPrice && (
          <Badge colorScheme="orange">
            ประหยัด ฿{discountedPrice}
          </Badge>
        )}
        {!discountedPrice && (
          <Badge colorScheme="white" textColor='white'>
            .
          </Badge>
        )}
        <Link to={`/course/${course.id}`}>
          <Button colorScheme="teal" mt={2}>
            ดูชุดข้อสอบนี้
          </Button>
        </Link>
      </Stack>
    </Box>
  );
};

const CourseList = ({ courses, onSort }) => {

  return (
    <>
      <Flex justify="space-between" align="center" mb={4}>
        <Heading as="h2" size="lg" color="teal.600">
        </Heading>
        <Select
          placeholder="จัดเรียงตาม"
          onChange={(e) => onSort(e.target.value)}
          maxWidth="200px"
        >
          <option value="date">วันที่ (ใหม่ที่สุด)</option>
          <option value="alphabet">ตัวอักษร (A-Z)</option>
          <option value="price">ราคา (ต่ำ-สูง)</option>
        </Select>
      </Flex>
      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
        {courses.map((course, index) => (
          <CourseCard key={index} course={course} />
        ))}
      </SimpleGrid>
    </>
  );
};


const CoursePage = () => {
  const dispatch = useDispatch()
  const initFetch = useCallback(() => {
    dispatch(GET_COURSES_BY_GUEST(''))
  }, [dispatch])
  useEffect(() => {
    initFetch()
  }, [initFetch])
  const courses = useSelector((state) => state.guests.lists)
  // const lists = useSelector((state) => state)

  const [filteredCourses, setFilteredCourses] = useState([]);
  const [selectedCourseType, setSelectedCourseType] = useState('all');

  useEffect(() => {
    if (courses.length > 0) {
      setFilteredCourses(courses);
    }
  }, [courses]);

  const handleSearch = (searchTerm) => {
    const filtered = courses.filter((course) =>
      course.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredCourses(filtered);
  };

  const handleFilter = ({ coursetype, classroom, subject }) => {
    let filtered = courses;

    if (coursetype) {
      setSelectedCourseType(coursetype); // อัปเดต state
    }

    if (coursetype === "free") {
      filtered = filtered.filter((course) => course.is_free === true);
    }

    if (classroom.length > 0) {
      filtered = filtered.filter((course) => classroom.includes(course.class));
    }

    if (subject.length > 0) {
      filtered = filtered.filter((course) => subject.includes(course.subject));
    }

    setFilteredCourses(filtered);
  };

  const handleSort = (sortOption) => {
    let sortedCourses = [...filteredCourses];

    if (sortOption === "date") {
      sortedCourses.sort((a, b) => new Date(b.date) - new Date(a.date));
    } else if (sortOption === "alphabet") {
      sortedCourses.sort((a, b) => a.name.localeCompare(b.name));
    } else if (sortOption === "price") {
      sortedCourses.sort((a, b) => {
        // Calculate sale price for both courses
        const priceA = a.discount ? parseFloat(a.price) - parseFloat(a.discount) : parseFloat(a.price);
        const priceB = b.discount ? parseFloat(b.price) - parseFloat(b.discount) : parseFloat(b.price);

        // Compare the sale prices
        return priceA - priceB; // Ascending order
      });
    }

    setFilteredCourses(sortedCourses);
  };

  return (
    <Container maxW={'7xl'}>
      <>
        <Flex direction={{ base: "column", lg: "row" }} p={6} gap={6}>
          {/* Left Filter Column */}
          <Box flex="1" maxW={{ base: "100%", lg: "300px" }}>
            <FilterBar onFilter={handleFilter} />
          </Box>

          {/* Right Search and Course List Column */}
          <Box flex="3">
            <SearchBar onSearch={handleSearch} />
            <Heading as="h2" size="lg" color="teal.600">
              ชุดข้อสอบ{selectedCourseType == 'all' ? 'ทั้งหมด' : 'ฟรี'}
            </Heading>
            {filteredCourses.length > 0 ? (
              <CourseList courses={filteredCourses} onSort={handleSort} />
            ) : (
              <Text>Loading courses...</Text> // แสดงข้อความถ้าไม่มีข้อมูล
            )}
          </Box>
        </Flex>
      </>
    </Container>
  );
};

export default CoursePage;
